module.exports = __webpack_public_path__ + "ef4b31f68e166338bfdfc0232425a699.pdf";